import UploadFileCreate from "./UploadFileCreate";
import DownloadPDFList from "./DownloadPDFList";

export default {
    list: DownloadPDFList,
    create: UploadFileCreate
};